export default "__VITE_ASSET__Caj_$bh4__"